import React, { useState, useEffect, useCallback } from 'react';
import _ from 'lodash';
import cx from 'classnames';

import { ExternalFormWidgetContext } from '..';
import styles from '../style.module.scss';

export const HubspotFormView = ({ form, uid }) => {
  const portalId = _.get(form.configuration, "portalId", null);
  const formId = _.get(form.configuration, "guid", null);
  const region = _.get(form, "region", null);
  const context = React.useContext(ExternalFormWidgetContext);
  const widgetContextRef = React.useRef(null);

  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    widgetContextRef.current = context;
  }, [context]);

  useEffect(() => {
    appendScript();
  }, [])

  useEffect(() => {
    if (window && window.hbspt) {
      window.hbspt.forms.create({
        region: region || "na1",
        portalId: portalId,
        formId: formId,
        target: `#contact_form_${uid}`,
        onFormSubmit: (form) => {

        },
        onFormSubmitted: (event, form) => {
          const email = form.submissionValues.email;

          var contactRequest = {
            email: email
          }

          handleFormSubmit(contactRequest)
        }
      });
    }

  }, [formId, scriptLoaded, context])

  const handleFormSubmit = useCallback((contactRequest) => {
    const widgetContext = widgetContextRef.current;
    if (widgetContext && widgetContext.onFormSubmit) {
      widgetContext.onFormSubmit(contactRequest, widgetContext.parent);
    }
  }, [widgetContextRef]);

  const appendScript = () => {
    if (!window || window.hbspt) return;

    const script = document.createElement("script");
    script.src = `https://js.hsforms.net/forms/shell.js`;
    script.key = "hubspot_form"
    script.type = "text/javascript"
    script.onload = () => (window && window.hbspt ? setScriptLoaded(true) : null);
    document.body.appendChild(script);
  }

  return (
    <div className={cx(styles.externalForm)}>
      <div id={`contact_form_${uid}`}></div>
    </div>
  )
}
